import React, { useEffect, useState } from 'react';
import classnames from 'classnames/bind';

import Style from './index.less';
import { Button, Icon } from '@/components';
import { useI18N } from '@/utils/locale';
import { useRafTimeout } from 'ahooks';
import { useIntl } from 'umi';
import { meeting, user } from '@/models';
import { event } from '@/.umi/plugin-locale/locale';
import { eventBus } from '@/utils/event';

const $c = classnames.bind(Style);

const Loading = React.memo<{
  type: 'whiteboard' | 'code';
}>(({ type }) => {
  const [progress, setProgress] = React.useState(0);
  const $l = useI18N();
  const [codeLoadFail, setCodeLoadFail] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const typeMap = React.useMemo(() => {
    return {
      whiteboard: {
        icon: 'icon-whiteboard1',
        text: $l('OPENING_INTERACTIVE_WHITEBOARD'),
      },
      code: {
        icon: 'icon-code',
        text: $l('OPENING_CODE_EDITOR'),
      },
    };
  }, []);

  React.useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      setProgress(1 - Math.exp((-1 * (Date.now() - start)) / 200));
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const showLoadFail = () => {
    if (meeting?.codeEditorLoading) {
      setCodeLoadFail(true);
    }
  };

  const openCodeEditor = () => {
    setCodeLoadFail(false);
    meeting?.setCodeEditorLoading(false);
    meeting?.setCodeEditorEnabled(false);
    if (meeting?.codeEditorEnabledUid === user.uid) {
      eventBus.emit('openCodeEditor');
    } else {
      //  获取代码编辑器最新状态
      meeting.getInfo({ meetingId: window.$meetingId }, true).then((res) => {
        if (res.data?.codeEditorStatus?.codeEditorEnabled) {
          meeting?.setCodeEditorLoading(true);
          meeting?.setCodeEditorEnabled(true);
        }
      });
    }
    handleShowLoadFail();
  };

  const handleShowLoadFail = () => {
    setTimeout(() => {
      showLoadFail();
    }, 15000);
  };

  useEffect(() => {
    handleShowLoadFail();
  }, []);

  return (
    <div className={$c('loading-container')}>
      <div className={$c('loading-item')}>
        {codeLoadFail ? (
          <>
            <Icon className={$c('fialicon')} name="icon-code-fail" mode="symbol" size={40} />
            <span className={$c('fail')}>
              <div className={$c('fialtext')}>{formatMessage({ id: 'openCodeFail' })}</div>
              <Button type="link" className={$c('open')} onClick={openCodeEditor}>
                {formatMessage({ id: 'reOpen' })}
              </Button>
            </span>
          </>
        ) : (
          <>
            <Icon className={$c('icon')} name={typeMap[type].icon} />
            <div className={$c('bar')}>
              <div className={$c('inner-bar')} style={{ width: `${progress * 100}%` }} />
            </div>
            <div className={$c('text')}>{typeMap[type].text}</div>
          </>
        )}
      </div>
    </div>
  );
});

export default Loading;
